
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.dispatchEvent(new Event('change'));
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      //this.hideUnavailable();
      this.updateSku();
      this.updateInventory();
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateSku(){
    let skuElement = document.querySelector(".product__info-container").querySelector(".product_sku");
    skuElement.innerHTML = `sku: ${this.currentVariant.sku}`
  }
  
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelector(`.js-grid-item`);
    mediaGalleries.querySelector(`[id=ProductImageWrapper-${this.currentVariant.featured_image.id}]`) != null ? mediaGalleries.querySelector(`[id=ProductImageWrapper-${this.currentVariant.featured_image.id}]`).classList.remove("hidden") : '';
    mediaGalleries.querySelectorAll(".product-single__featured-image-wrapper").forEach(mediaGallery => 
      {
        if(mediaGallery.getAttribute("id") === `ProductImageWrapper-${this.currentVariant.featured_image.id}`){
          mediaGallery.classList.remove("hidden");
        }else {
            mediaGallery.classList.add("hidden");
        }
      });

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    document.querySelector("#ProductSelect-product-template").querySelectorAll("option").forEach((option) => parseInt(option.getAttribute("value"))===this.currentVariant.id ? option.setAttribute("selected", "selected") : option.removeAttribute("selected"))
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  hideUnavailable(){
    /*console.log(this.options);
    console.log(this.variantData);
    this.option1 = null, this.option2 = null, this.option3 = null;
    if(this.options[0] != undefined){
      this.option1 = this.options[0];
    }
    if(this.options[1] != undefined){
      this.option2 = this.options[1];
    }
    if(this.options[2] != undefined){
      this.option3 = this.options[2];
    }
    this.querySelector(`input[type="radio"]"`).removeAttribute('disabled');
    this.unavailables = this.getVariantData().forEach((variant) => {
      if(this.option1 == variant.option1 && this.option2 == variant.option2){
        if(variant.available){
          
        }else{
          this.querySelector(`input[type="radio"][value="${this.option3}"`).setAttribute('disabled');
        }
      }
      console.log(variant);
    });*/
  }
  
  updateInventory(){
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`variant-inventory-${this.dataset.section}`);
        const source = html.getElementById(`variant-inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`variant-inventory-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }
  
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`ProductPrice`);
        const source = html.getElementById(`ProductPrice`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`ProductPrice`);

        if (price) price.classList.remove('visibility-hidden');
    
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        /* hide/show soldout/unavailable variants */
        
        for (let index = 0; index < this.options.length; index++) {
          const mainFieldset = this.querySelectorAll(`.product-form__input`)[index].querySelectorAll(`[type="radio"]`);
          const newOptions = html.querySelectorAll(`.product-form__input`)[index].querySelectorAll(`[type="radio"]`);
          //console.log(newOptions);
          mainFieldset.forEach((input, index) => {
            input.setAttribute('class', newOptions[index].classList.value);
            /*if(newOptions[index].hasAttribute('disabled')){
              input.setAttribute('disabled', "");
            }else{
              input.removeAttribute('disabled');
            }*/
          });
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product_form_8033153581235`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    addButton.style.display = "block";
    document.querySelector(".btn--view-cart") ? document.querySelector(".btn--view-cart").style.display = "none" : '';
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product_form_8033153581235`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    console.log(this.oldOptions)
    this.change = this.options.filter(option => !this.oldOptions.find(x => x === option)).map(option => option);
    this.newVariant = this.variantData.filter(variant => {      
      if(variant.title.includes(this.change[0]) && variant.available){
        return variant;
      }
    });
    this.newVariant.forEach((variant, k) => {
      if(k == 0){
        variant.options.forEach((opt, key) => {
          let o = this.querySelectorAll('.product-form__input')[key].querySelector(`input[value='${opt}']`);
          o.checked = true;
          document.querySelector(`variant-radios`).dispatchEvent(new Event('change'));
        });
      }
    });
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    //this.dispatchEvent(new Event('change'));
  }

  updateOptions() {
    const fieldsets = Array.from(document.querySelectorAll('fieldset'));
    this.oldOptions = this.options;
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);